import React from "react";
import { Image50, Image51, Image52, Image53, Logo3 } from "../../assets";
import {
  BePartSection,
  DiscoverArchiveSection,
  SubscriptionSection,
  SupportSection,
  UploadArchive,
} from "../../components";
import AccessKeySection from "../../components/Features/AccessKeySection/AccessKeySection";
import "./ArchiveLanding.scss";
import { useNavigate } from "react-router-dom";

const ArchiveLanding = () => {
  const navigate = useNavigate();
  const handleArchiveVisit = () => {
    navigate("/archive-access");
  };
  return (
    <div className="ArchiveLanding">
      <DiscoverArchiveSection
        image={Image52}
        title="ARCHIVE PROJECT"
        linkText="Archive"
        subtitle=""
      />
      <button onClick={handleArchiveVisit} className="Unlock">
        {" "}
        {">> Unlock Archive <<"}
      </button>
      <SubscriptionSection
        title="ARCHIVE PROJECT"
        content={`ARCHIVE PROJECT is a decentralized web archive built on blockchain preserves cultural materials photos, documents, journals, and historical records in a permanent, verifiable form. Each item is stored through a hybrid model: the content itself lives in decentralized storage, while hashes and metadata are written to the blockchain, ensuring authenticity and preventing tampering. Access to certain collections is managed through NFT keys: owning the key in a connected wallet grants rights to view or decrypt restricted materials. Thanks to distributed storage, cryptographic integrity checks, and transparent on-chain provenance, the archive remains reliable, censorship-resistant, and accessible even if individual nodes or servers fail. The result is a long-term digital library where every record can be traced, verified, and preserved for future generations.`}
        imageSrc={Image53}
      />
      <AccessKeySection
        image={Image51}
        title="NFT Access Key"
        description={`
    In the Archive Project, access to restricted archival materials is managed through a single, unified mechanism — 
    <strong>the NFT Access Key</strong>. Think of the archive as a vast library, and the NFT Access Key as a lifetime library card granting you entry. 
    Unlike traditional systems that rely on accounts, passwords or centralized databases, the authorization process here is fully on-chain.

    <br/><br/>

    Your NFT is more than just a collectible it is a cryptographic key. Once you purchase an NFT Access Key, it is transferred directly to your crypto wallet. 
    This key is permanently yours, providing lifelong access to the specific archive section it corresponds to. Each key unlocks a distinct collection, 
    whether it’s a region, a country or a historically significant area.

    <br/><br/>

    When you connect your wallet to the website, ownership of the NFT is verified directly on the blockchain. 
    If the key is in your wallet, access is immediately granted — just like showing your library card to enter a private reading room.
  `}
      />
      <SupportSection color="black" lineHeight="5px" />

      <UploadArchive
        image={Image50}
        title="Palestine & Neighboring Countries"
        priceEth="0.006 ETH"
        priceUsd="≈ 19 USD"
        content={`Throughout its modern history, Palestine has experienced a complex interplay of political upheaval, cultural flourishing, and social transformation — all of which have left an enduring impact on its national identity. From the late Ottoman period through the British Mandate and beyond, events such as land dispossession, revolts, and the rise of nationalist movements have shaped the trajectory of Palestinian society. These political shifts were not isolated incidents but part of a broader struggle for sovereignty, dignity, and representation.
During the British Mandate era, several influential leaders played pivotal roles in shaping Palestinian political life. Figures such as Haj Amin al-Husseini (Grand Mufti of Jerusalem), Raghib al-Nashashibi (Mayor of Jerusalem), and Awni Abd al-Hadi (co-founder of the Independence Party) stood at the forefront of national leadership. Alongside them, political actors, and nationalist thinkers articulated visions for Palestinian self-determination.

At the same time, cultural and intellectual life in Palestine developed rapidly — with newspapers, literature, public gatherings, and educational initiatives fostering a distinct sense of community and purpose. From political leaders to poets, business owners, and grassroots organizers, a wide array of voices helped shape both the resistance and the fabric of daily life. The tension between imposed colonial structures and organic civic engagement gave rise to a resilient social consciousness — one rooted in land, memory, and shared aspiration.`}
        button1="Buy Access Key"
        button2="Purchase Access (Card/PayPal)"
        footerText=""
        button3=""
      />
      <SupportSection color="black" lineHeight="5px" />
      <BePartSection
        logo={Logo3}
        title="ARCHIVE PROJECT"
        subtitle="by funooni"
      />
    </div>
  );
};

export default ArchiveLanding;
